// import React from 'react';
// import { MapPin, Package, Star } from 'lucide-react';

// const ShopCard = ({ shop, featured = false, delay = 0 }) => {
//   const handleClick = () => {
//     window.open(`https://toko.mpstore.co.id/${shop.alias}`, '_blank');
//   };

//   return (
//     <div
//       className="bg-surface border border-border rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer group animate-slide-up"
//       onClick={handleClick}
//       style={{ animationDelay: `${delay}ms` }}
//     >
//       {/* Shop Image/Placeholder */}
//       <div className="relative h-40 bg-gradient-to-br from-primary/10 to-primary/5 overflow-hidden">
//         {featured && (
//           <div className="absolute top-3 left-3 z-10">
//             <div className="bg-secondary text-white px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1">
//               <Star className="w-3 h-3 fill-white" />
//               <span>UMKM Pilihan</span>
//             </div>
//           </div>
//         )}
        
//         {shop.store_avatar ? (
//           <img
//             src={shop.store_avatar}
//             alt={shop.store_name}
//             className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
//           />
//         ) : (
//           <div className="w-full h-full flex items-center justify-center">
//             <div className="text-6xl opacity-30">🏪</div>
//           </div>
//         )}
        
//         {/* Status Badge */}
//         <div className="absolute bottom-3 right-3">
//           <div
//             className={`px-3 py-1 rounded-full text-xs font-semibold ${
//               shop.is_open === 'open'
//                 ? 'bg-success/90 text-white'
//                 : 'bg-gray-500/90 text-white'
//             } backdrop-blur-sm`}
//           >
//             {shop.is_open === 'open' ? '🟢 Buka' : '🔴 Tutup'}
//           </div>
//         </div>
//       </div>

//       {/* Shop Info */}
//       <div className="p-4">
//         <h3 className="font-bold text-lg text-foreground mb-2 line-clamp-1 group-hover:text-primary transition-colors">
//           {shop.store_name}
//         </h3>
        
//         <div className="flex items-start gap-2 mb-3">
//           <MapPin className="w-4 h-4 text-muted-foreground mt-0.5 flex-shrink-0" />
//           <p className="text-sm text-muted-foreground line-clamp-2">{shop.address}</p>
//         </div>

//         <div className="flex items-center justify-between text-sm">
//           <div className="flex items-center gap-1 text-muted-foreground">
//             <Package className="w-4 h-4" />
//             <span>{shop.total_product} produk</span>
//           </div>
//           <div className="font-semibold text-primary">{shop.distance}</div>
//         </div>

//         {/* Products Preview */}
//         {shop.products && shop.products.length > 0 && (
//           <div className="mt-3 pt-3 border-t border-border">
//             <p className="text-xs text-muted-foreground mb-2">Produk populer:</p>
//             <div className="flex gap-2 overflow-x-auto scrollbar-hide">
//               {shop.products.slice(0, 3).map((product) => (
//                 <div
//                   key={product.product_id}
//                   className="flex-shrink-0 w-16 h-16 rounded-lg bg-muted overflow-hidden border border-border"
//                 >
//                   {product.img_url ? (
//                     <img
//                       src={product.img_url}
//                       alt={product.product_name}
//                       className="w-full h-full object-cover"
//                     />
//                   ) : (
//                     <div className="w-full h-full flex items-center justify-center text-2xl">📦</div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         <button className="w-full mt-4 py-2.5 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary-hover transition-colors">
//           Lihat Produk
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ShopCard;

import React from 'react';
import { MapPin, Package, Star } from 'lucide-react';

const ShopCard = ({ shop, featured = false, delay = 0 }) => {
  const handleClick = () => {
    window.open(`https://toko.mpstore.co.id/${shop.alias}`, '_blank');
  };

  return (
    <div
      className="bg-surface border border-border rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer group animate-slide-up"
      onClick={handleClick}
      style={{ animationDelay: `${delay}ms` }}
    >
      {/* Shop Image/Placeholder */}
      <div className="relative h-40 bg-gradient-to-br from-primary/10 to-primary/5 overflow-hidden">
        {featured && (
          <div className="absolute top-3 left-3 z-10">
            <div className="bg-secondary text-white px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1">
              <Star className="w-3 h-3 fill-white" />
              <span>UMKM Pilihan</span>
            </div>
          </div>
        )}
        
        {shop.store_avatar ? (
          <img
            src={shop.store_avatar}
            alt={shop.store_name}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <div className="text-6xl opacity-30">🏪</div>
          </div>
        )}
        
        {/* Status Badge */}
        <div className="absolute bottom-3 right-3">
          <div
            className={`px-3 py-1 rounded-full text-xs font-semibold ${
              shop.is_open === 'open'
                ? 'bg-success/90 text-white'
                : 'bg-gray-500/90 text-white'
            } backdrop-blur-sm`}
          >
            {shop.is_open === 'open' ? '🟢 Buka' : '🔴 Tutup'}
          </div>
        </div>
      </div>

      {/* Shop Info */}
      <div className="p-3 sm:p-4">
        <h3 className="font-bold text-sm sm:text-lg text-foreground mb-1 sm:mb-2 line-clamp-1 group-hover:text-primary transition-colors">
          {shop.store_name}
        </h3>
        
        <div className="flex items-start gap-1 sm:gap-2 mb-2 sm:mb-3">
          <MapPin className="w-3 h-3 sm:w-4 sm:h-4 text-muted-foreground mt-0.5 flex-shrink-0" />
          <p className="text-xs sm:text-sm text-muted-foreground line-clamp-2">{shop.address}</p>
        </div>

        <div className="flex items-center justify-between text-xs sm:text-sm">
          <div className="flex items-center gap-1 text-muted-foreground">
            <Package className="w-3 h-3 sm:w-4 sm:h-4" />
            <span>{shop.total_product} produk</span>
          </div>
          <div className="font-semibold text-primary text-xs sm:text-sm">{shop.distance}</div>
        </div>

        {/* Products Preview */}
        {shop.products && shop.products.length > 0 && (
          <div className="mt-2 sm:mt-3 pt-2 sm:pt-3 border-t border-border">
            <p className="text-xs text-muted-foreground mb-2 hidden sm:block">Produk populer:</p>
            <div className="flex gap-1 sm:gap-2 overflow-x-auto scrollbar-hide">
              {shop.products.slice(0, 3).map((product) => (
                <div
                  key={product.product_id}
                  className="flex-shrink-0 w-12 h-12 sm:w-16 sm:h-16 rounded-lg bg-muted overflow-hidden border border-border"
                >
                  {product.img_url ? (
                    <img
                      src={product.img_url}
                      alt={product.product_name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-lg sm:text-2xl">📦</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        <button className="w-full mt-3 sm:mt-4 py-2 sm:py-2.5 text-xs sm:text-base bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary-hover transition-colors">
          Lihat Produk
        </button>
      </div>
    </div>
  );
};

export default ShopCard;
